// Editor mounts only after the environment (incl. ?code= session-code exchange)
// is set: EditorApp reads window.idealStudioTrainingId at mount.
export const bootEditor = async ({ hasValidToken, setEnvironment, assetGrantReady, render }) => {
  if (hasValidToken) {
    try {
      await setEnvironment();
    } catch (e) {
      console.error("Environment setup failed", e);
    }
    // First /api/f/ asset request must not beat the aidea_asset cookie grant.
    if (assetGrantReady) await assetGrantReady();
  }
  render();
};
